import { Font } from "@/src/components";
import styles from "./index.module.scss";
import { useEffect, useRef, useState } from "react";
import AccountIcon from "@/src/components/icons/AccountIcon";
import { ShowcaseProduct, WordStyling } from "@/src/utils/types/landingpage";

export default function LandingProducts({
  showcase,
  listWordStyling,
}: {
  showcase: ShowcaseProduct;
  listWordStyling: WordStyling[];
}) {
  const containerRef = useRef(null);

  const callbackFn: IntersectionObserverCallback = (
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver,
  ) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(styles["visible"]);
        observer.unobserve(entry.target)
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFn);
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, [containerRef]);

  
  return (
    <div
      ref={containerRef}
      className={styles.box_card}
    >
      <img
        className={styles.image_thumbnail}
        src={`${process.env.NEXT_PUBLIC_IMAGES}/${showcase.thumbnail_produk}`}
        alt={showcase.nama_produk}
      />
      <div className={styles.information_wrapper}>
        <Font variant='title-4-bold' color='dark40' >
          {showcase.nama_produk}
        </Font>
        <div className={styles.lozenge}>
          <Font variant={'caption-1-semibold'} color={'green100'} >
            {showcase.tipe_produk}
          </Font>
        </div>
        <Font variant={'subtitle-2-medium'} color={'light80'} listWordStyling={listWordStyling}>
          {showcase.deskripsi_produk}
        </Font>
        <div className={styles.owner_wrapper}>
          <AccountIcon />
          <Font variant={'subtitle-2-semibold'} color={'dark30'} >
            {showcase.product_owner}
          </Font>
        </div>
      </div>
    </div>
  );
}
